// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4205":"5bdb0082","6533":"e997e87f"}[chunkId] + ".chunk.css";
};